import albumOrderStyles from '../LabOrderDetails/LabOrderDetailsInformation/OrderSummary/AlbumOrderSummary.module.css';
import styles from '../../pages/ProductSelection.module.css';
import PhotoModal, { PhotoModalImage } from './PhotoModal';

const AlbumPhotoModal = ({ isOpen, onClose, imageUrl, fileName, coverText, allowCoverTextWithoutImage = false }) => {
  const showCoverTextOnly =
    allowCoverTextWithoutImage &&
    !imageUrl &&
    coverText !== undefined &&
    coverText !== null &&
    String(coverText).trim() !== '';

  return (
    <PhotoModal
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="Enlarged photo view"
      contentClassName={showCoverTextOnly ? styles.modalContentWithAlbumCover : ''}
      imageContainerClassName={showCoverTextOnly ? styles.imageContainerWithAlbumCover : ''}
      fileName={fileName || undefined}
    >
      {showCoverTextOnly ? (
        <div className={albumOrderStyles.coverPlaceholderModal}>
          <div className={albumOrderStyles.albumCoverFaceModalInner}>
            <span className={albumOrderStyles.albumCoverFaceTextModal}>{coverText}</span>
          </div>
        </div>
      ) : (
        <PhotoModalImage
          imageUrl={imageUrl}
          alt={fileName || 'Album photo'}
          isOpen={isOpen}
        />
      )}
    </PhotoModal>
  );
};

export default AlbumPhotoModal;
